<template>
  <PageContent
    type="center"
    :compClass="'flex flex-col space-y-6'"
    v-if="userData !== null"
  >
    <div
      class="flex flex-col px-4 py-4 lg:flex-row lg:items-center bg-white lg:rounded-lg lg:px-4 lg:py-2 -mx-6 -mt-6 lg:-mx-0 lg:-mt-0"
    >
      <ol role="list" class="flex-1 flex items-center space-x-2">
        <li>
          <router-link
            class="text-gray-400 hover:text-gray-500"
            :to="{ name: 'AdminHome' }"
            ><svg
              class="flex-shrink-0 h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
              /></svg
          ></router-link>
        </li>

        <li>
          <div class="flex items-center">
            <svg
              class="flex-shrink-0 h-5 w-5 text-gray-300"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
              aria-hidden="true"
            >
              <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
            </svg>
            <router-link
              class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
              :to="{ name: 'AdminUsers' }"
              >Users</router-link
            >
          </div>
        </li>

        <li v-if="userData !== null">
          <div class="flex items-center">
            <svg
              class="flex-shrink-0 h-5 w-5 text-gray-300"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
              aria-hidden="true"
            >
              <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
            </svg>
            <router-link
              class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
              :to="{
                name: 'AdminUserInformation',
                params: { uid: userData.id }
              }"
            >
              {{ userData.name }}
            </router-link>
          </div>
        </li>
      </ol>
      <div class="mt-4 lg:mt-0">
        <div class="lg:hidden">
          <label for="tabs" class="sr-only">Select a tab</label>
          <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
          <select
            id="tabs"
            name="tabs"
            class="block w-full focus:ring-blue-500 focus:border-blue-500 border-gray-300 rounded-md"
            v-model="selectedPage"
          >
            <option value="overview">Overview</option>
            <option value="videos">Videos</option>
            <option value="sales">Sales</option>
          </select>
        </div>
        <div class="hidden lg:block">
          <nav class="flex space-x-4" aria-label="Tabs">
            <router-link
              class="text-gray-600 hover:text-gray-800 px-3 py-2 font-medium text-sm rounded-md"
              active-class="bg-gray-200 text-gray-800"
              :to="{ name: 'AdminUserOverview' }"
              >Overview</router-link
            >
            <router-link
              class="text-gray-600 hover:text-gray-800 px-3 py-2 font-medium text-sm rounded-md"
              active-class="bg-gray-200 text-gray-800"
              :to="{ name: 'AdminUserVideos' }"
              v-if="!userData.role.includes('media')"
              >Videos</router-link
            >
            <router-link
              class="text-gray-600 hover:text-gray-800 px-3 py-2 font-medium text-sm rounded-md"
              active-class="bg-gray-200 text-gray-800"
              :to="{ name: 'AdminUserSales' }"
              v-if="!userData.role.includes('media')"
              >Sales</router-link
            >
          </nav>
        </div>
      </div>
    </div>

    <router-view :userData="userData"></router-view>

    <UserResetPasswordModal />
    <UserChangePermissionsModal />
    <UserSuspendModal />
  </PageContent>
</template>

<script>
import * as Config from "@/config";

import PageContent from "@/components/PageContent";

import UserResetPasswordModal from "@/screens/admin/modals/UserResetPasswordModal";
import UserChangePermissionsModal from "@/screens/admin/modals/UserChangePermissionsModal";
import UserSuspendModal from "@/screens/admin/modals/UserSuspendModal";

export default {
  name: "AdminNetworks",
  data() {
    return {
      userData: null,
      selectedPage: "overview"
    };
  },
  components: {
    PageContent,
    UserResetPasswordModal,
    UserChangePermissionsModal,
    UserSuspendModal
  },
  mounted() {
    this.getUserInfo();
    this.updateSelectedPage();
  },
  methods: {
    async getUserInfo() {
      try {
        let res = await this.$http.get(
          Config.apiPath + "/api/v2/admin/users/" + this.$route.params.uid
        );
        this.userData = res.data;
      } catch (e) {}
    },
    updateSelectedPage() {
      let currentRouteName = this.$route.name;
      if (currentRouteName == "AdminUserOverview") {
        this.selectedPage = "overview";
      } else if (currentRouteName == "AdminUserVideos") {
        this.selectedPage = "videos";
      } else if (currentRouteName == "AdminUserSales") {
        this.selectedPage = "sales";
      }
    }
  },
  watch: {
    "$route.name": function() {
      this.updateSelectedPage();
    },
    selectedPage: function(val) {
      if (val == "overview" && this.$route.name !== "AdminUserOverview") {
        this.$router.push({ name: "AdminUserOverview" });
      } else if (val == "videos" && this.$route.name !== "AdminUserVideos") {
        this.$router.push({ name: "AdminUserVideos" });
      } else if (val == "sales" && this.$route.name !== "AdminUserSales") {
        this.$router.push({ name: "AdminUserSales" });
      }
    }
  }
};
</script>
